export const COUNTRY_LOADED = 'country_loaded';
export const COUNTRY_UNKNOWN = 'country_unknown';
